"use client";

import { useEffect } from "react";

const RELOAD_KEY = "frogstat:chunk-reload-at";
const RELOAD_COOLDOWN_MS = 30_000;

function isChunkLoadFailure(value: unknown): boolean {
  const message = value instanceof Error ? value.message : String(value ?? "");
  return message.includes("ChunkLoadError") || message.includes("Loading chunk");
}

function reloadOnce() {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Number.isFinite(last) && Date.now() - last < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    // Если sessionStorage недоступен, лучше один раз обновить страницу, чем
    // оставить пользователя на сломанном bundle после деплоя/пересборки.
  }

  window.location.reload();
}

export default function ChunkLoadRecovery() {
  useEffect(() => {
    const onUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (isChunkLoadFailure(event.reason)) reloadOnce();
    };

    const onError = (event: ErrorEvent) => {
      if (isChunkLoadFailure(event.error) || isChunkLoadFailure(event.message)) {
        reloadOnce();
      }
    };

    window.addEventListener("unhandledrejection", onUnhandledRejection);
    window.addEventListener("error", onError);

    return () => {
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
      window.removeEventListener("error", onError);
    };
  }, []);

  return null;
}
